import { render, staticRenderFns } from "./faq_suport.vue?vue&type=template&id=cd8b0150&"
import script from "./faq_suport.vue?vue&type=script&lang=js&"
export * from "./faq_suport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports